module.exports = __webpack_public_path__ + "static/media/296125.4bb3379b.jpg";